import { put, all, takeLatest, select } from "redux-saga/effects";
import * as actionTypes from "./actionTypes";
import API from "../../commonUtils/API.js";
import { toast } from "react-toastify";
import { handleApiError } from "../../commonUtils/Functions";

function* getLeadSourcesSaga({ params }) {
    const { currentPage, perPage } = params;

    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const filters = yield select((state) => state.LeadSources.filters);

        let queryString = `currentPage=${currentPage}&perPage=${perPage}`;
        if(filters.keyword) queryString = queryString.concat(`&keyword=${encodeURIComponent(filters.keyword)}`);

        const { data } = yield API.get(`/lead-sources?${queryString}`);

        if (data.success) {
            yield put({ type: actionTypes.GET_LEAD_SOURCES_SUCCESS, payload: data.data });
        } else {
            toast.error("Oops! Something went unexpectedly wrong.");
            yield put({ type: actionTypes.GET_LEAD_SOURCES_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Oops! Something went unexpectedly wrong.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.GET_LEAD_SOURCES_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* createLeadSourceSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });
        const { formData } = payload;
        const { data } = yield API.post("/lead-sources", formData);
        if (data.success) {
            yield put({ type: actionTypes.CREATE_LEAD_SOURCE_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_LEAD_SOURCES, params: {} });
        } else {
            toast.error(data?.message || "Could not save lead source.");
            yield put({ type: actionTypes.CREATE_LEAD_SOURCE_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save lead source.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_LEAD_SOURCE_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* updateLeadSourceSaga({ payload }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });
        const { id, formData } = payload;
        const { data } = yield API.put(`/lead-sources/${id}`, formData);
        if (data.success) {
            const { pagination } = yield select((state) => state.LeadSources.LeadSourcesList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.UPDATE_LEAD_SOURCE_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_LEAD_SOURCES, params });
        } else {
            toast.error(data?.message || "Could not save updated lead source data.");
            yield put({ type: actionTypes.UPDATE_LEAD_SOURCE_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not save updated lead source data.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.UPDATE_LEAD_SOURCE_FAILURE, payload: data || { message: "Internal server error" } });
    }
}

function* updateLeadSourceStatusSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.patch(`/lead-sources/${Id}/status`);

        if (data.success) {
            const { pagination } = yield select((state) => state.LeadSources.LeadSourcesList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.UPDATE_LEAD_SOURCE_STATUS_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_LEAD_SOURCES, params });
        } else {
            toast.error(data?.message || "Could not update lead source status.");
            yield put({ type: actionTypes.UPDATE_LEAD_SOURCE_STATUS_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not update lead source status.");
        const data = error?.response?.data;
        yield put({ type: actionTypes.CREATE_LEAD_SOURCE_FAILURE, payload: data || { message: "Internal server error" } });
    }
};

function* deleteLeadSourceSaga({ Id }) {
    try {
        yield put({ type: actionTypes.SET_LOADING, payload: true });

        const { data } = yield API.delete(`/lead-sources/${Id}`);

        if (data.success) {
            const { pagination } = yield select((state) => state.LeadSources.LeadSourcesList);
            const params = { currentPage: pagination.currentPage, perPage: pagination.perPage };
            yield put({ type: actionTypes.DELETE_LEAD_SOURCE_SUCCESS, payload: data.data });
            yield put({ type: actionTypes.GET_LEAD_SOURCES, params });
        } else {
            toast.error(data?.message ||"Could not delete the lead source.");
            yield put({ type: actionTypes.DELETE_LEAD_SOURCE_FAILURE, payload: data });
        }

    } catch (error) {
        handleApiError(error, "Could not delete lead source.");
        const data = error?.response?.data;
        toast.error(data?.message ||"Could not delete the lead source.");
        yield put({ type: actionTypes.CREATE_LEAD_SOURCE_FAILURE, payload: data || { message: "Internal server error" } });
    }
};


function* LeadSourcesSaga() {
  yield all([
    takeLatest(actionTypes.GET_LEAD_SOURCES, getLeadSourcesSaga),
    takeLatest(actionTypes.CREATE_LEAD_SOURCE, createLeadSourceSaga),
    takeLatest(actionTypes.UPDATE_LEAD_SOURCE, updateLeadSourceSaga),
    takeLatest(actionTypes.UPDATE_LEAD_SOURCE_STATUS, updateLeadSourceStatusSaga),
    takeLatest(actionTypes.DELETE_LEAD_SOURCE, deleteLeadSourceSaga),
  ]);
}

export default LeadSourcesSaga;
